import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
import * as libHabitat from './habitat';
import * as libInvestor from './investor';
export const prefix = 'accounts';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ habitatID, investorID, investorAccountID }) => {
    return libInvestor.IDToName({ habitatID, investorID }) + SEPARATOR + prefixWithSeparator + investorAccountID;
};
export const validateName = genericValidateName([
    exactValidator(libHabitat.prefix),
    uuidValidator(),
    exactValidator(libInvestor.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split('/');
    return {
        habitatID: parts[1],
        investorID: parts[3],
        investorAccountID: parts[5],
    };
};
